/**
 * Dashboard remittance TDS is display-only.
 * Show the TDS line only when this user has a TDS rate or a TDS amount.
 * Does not change commission / remittance math.
 */
export function shouldShowDashboardUserTds({ tdsPercentage, tdsAmount } = {}) {
  return Number(tdsPercentage || 0) > 0 || Number(tdsAmount || 0) > 0;
}

export default shouldShowDashboardUserTds;
